import React from 'react';
import { useLocation } from 'react-router';
import ProgressTracker from 'components/ProgressTracker';
import { Row, Col } from 'reactstrap';
import { useTrack } from '../../../../products/WLC/contexts/TrackContext';
import { useWeek } from '../../../../products/WLC/contexts/WeekContext';
import { useWLC } from '../../../../products/WLC/contexts/WLCContext';

const TrackWeekHeader = () => {
  const location = useLocation();
  const { weeks = [], metadata: trackMetadata, getWeekNumber, trackList = [] } = useTrack() || {};
  const { wlcProgress } = useWLC() || {};
  const { week } = useWeek() || {};
  const normalizedWeeks = Array.isArray(weeks) ? weeks : [];
  const normalizedTrackList = Array.isArray(trackList) ? trackList : [];
  const previewWeekNumber = location?.state?.previewWeekNumber;
  const weekNumber =
    previewWeekNumber || (week?.slug && typeof getWeekNumber === 'function' ? getWeekNumber(week.slug) : 0);
  const nextTrackSlug = wlcProgress?.trackPriorityOrder?.[0];
  const nextTrackTitle = normalizedTrackList.find(v => v?.slug === nextTrackSlug)?.title || '';
  const trackTitle = location?.state?.previewTrackTitle || trackMetadata?.title || '';
  const title = week?.displayProps?.title || week?.title || 'Weekly Guide';
  const isTrackPreview = !!location?.state?.isTrackPreview;
  const isGettingStarted = week?.slug === 'getting-started';

  return (
    <>
      {!isTrackPreview ? (
        <Row className="d-md-none">
          <Col className="text-lg-left pt-3">
            <ProgressTracker
              currentStep={weekNumber}
              totalSteps={Math.max(normalizedWeeks.length, 1)}
              title="Let’s Do This!"
              goToStep={() => {}}
            />
          </Col>
        </Row>
      ) : null}
      <Row>
        <Col className="text-center text-lg-left pt-lg-4">
          {isGettingStarted ? (
            <>
              <p className="mb-0 text-balance">This is your introductory week.</p>
              {nextTrackTitle ? (
                <p className="mb-0 text-balance">
                  Week <strong>{weekNumber}</strong> of your <strong>{nextTrackTitle}</strong> track starts on{' '}
                  <strong>Monday</strong>.
                </p>
              ) : (
                <p className="mb-0 text-balance">
                  Your first track starts on <strong>Monday</strong>.
                </p>
              )}
            </>
          ) : (
            <p className="mt-lg-3 mb-0 text-balance">
              {isTrackPreview ? (
                <>
                  You are previewing Week <strong>{weekNumber}</strong> of the <strong>{trackTitle}</strong> track.
                </>
              ) : (
                <>
                  You’re on Week <strong>{weekNumber}</strong> of the <strong>{trackTitle}</strong> track.
                </>
              )}
            </p>
          )}
        </Col>
      </Row>
      <Row>
        <Col className="pagetitle text-center text-lg-left">
          <h1 style={{ display: 'inline' }} className="text-balance">
            {title}
          </h1>
        </Col>
      </Row>
    </>
  );
};
export default TrackWeekHeader;
